
import { Component, Prop } from 'vue-property-decorator';
import Listing from 'ah-common-lib/src/common/components/listing/Listing.vue';
import { PaginatedQuery, AgentCommission } from 'ah-api-gateways';
import { agentCommissionTableFields } from './tableFields/commissionTableFields';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';

@Component
export default class AgentCommissionListing extends Listing<AgentCommission> {
  @Prop({ default: () => ({ tableFields: agentCommissionTableFields }) }) config!: { tableFields: any[] };

  formatCurrencyValue = formatCurrencyValue;

  protected loadDataRequest(query: PaginatedQuery) {
    return this.$services.trade.listAgentCommissions(query);
  }

  get currency() {
    return this.data.list[0]?.currency || 'GBP';
  }
}
